import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import { connect } from 'react-redux';
import Layout from '~/src/layout/_layout';
import * as base from '~/src/helpers/basePageFunc';
import { COLORS } from '@ertelecom/ui-react/assets/js/constants';
import ErrorPage from '~/pages/_error';
import AppLinks from '~/src/components/Intercom/appLinks';
import TariffListContainer from '~/src/components/Intercom/tariffs';
import { productPage as productPageData } from '~/src/components/Intercom/data';
import { getIntercomTariffs } from '~/src/store/actions/intercom';
import CallToActionBlock from '~/src/components/sections/CallToActionBlock';
import GridContainer from '@ertelecom/ui-react/components/layouts/gridContainer';
import Promo from '~/src/components/sections/Promo';

const itemsCallToActionText = [
  'Чтобы установить домофон в подъезде, ознакомьтесь с <a href="/domofon/meeting">инструкцией</a>.',
  'Скачайте мобильное приложение в одном из маркетплейсов.',
  'Зарегистрируйстесь в мобильном приложении и пользуйтесь услугой умного домофона.'
];

class IntercomTariffPage extends Component {

  static async getInitialProps(options) {
    const { req, res, store } = options;
    const relCanonical = get(req, 'headers.host', '');
    const { hostname } = await base.initialProps(options);
    const state = store.getState();
    const currentCity = state.city.currentCity;
    const domain = state.city.currentCity.domain;
    const productPage = productPageData(currentCity);
    await store.dispatch(getIntercomTariffs(currentCity.domain));
    if ((isEmpty(productPage) || isEmpty(productPage.product)) && res) {
 res.statusCode = 404;
}
    let content;
    let parseContent;
    await import('~/src/components/Intercom/content.json').then(resp => {
      content = (resp[domain]) ? resp[domain] : resp.all;
      parseContent = JSON.parse(JSON.stringify(content));
    });

    return ({
      relCanonical,
      hostname,
      productPage,
      parseContent,
      currentCity
    });
  }

  render() {
    const { hostname, relCanonical, tariffs, parseContent, currentCity } = this.props;
    const { productPage } = this.props;
    if (isEmpty(productPage) || isEmpty(productPage.product)) {
      return <ErrorPage statusCode={404}/>;
    }
    const titleH1 = 'Выберите тариф для домофона';
    return (
      <Layout
        title={`Тарифы домофонии от Дом.ru в ${currentCity.cityIn}`}
        relCanonical={`https://${relCanonical}/domofon`}
        description={`Провайдер Дом.ru предлагает доступные тарифы домофонии в ${currentCity.cityIn}. Оставьте заявку на сайте или по ☎  ${currentCity.phone}`}
        hostname={hostname}
        withMenu={true}
        withFooter={true}
        withChat={true}
        noindex={true}
      >
        <GridContainer>
          <TariffListContainer
          bgColor={productPage.invert_bg_color}
          title={titleH1}
          textColor={COLORS.black}
          tariffs={tariffs}
          nonBottomPadding
          nonTopPadding/>
          <AppLinks bgColor={productPage.invert_bg_color} nonTopPadding nonBottomPadding borderBottom/>
          <Promo pageContent={parseContent} columns={2}/>
        </GridContainer>
        <GridContainer id={'request'}>
          <CallToActionBlock
            title={<Fragment>Подключить <span>домофон</span></Fragment>}
            itemsCallToActionText={itemsCallToActionText}
            productId={'75'}
          />
        </GridContainer>
      </Layout>
    );
  }
}

IntercomTariffPage.propTypes = {
  city: PropTypes.object,
  alias: PropTypes.string,
  hostname: PropTypes.string,
  relCanonical: PropTypes.string,
  tariffs: PropTypes.array
};

IntercomTariffPage.defaultProps = {
  city: {},
  getIntercomTariffs: () => null,
  alias: '',
  hostname: '',
  relCanonical: '',
  tariffs: [],
};

const mapStateToProps = state => ({
  city: state.city.currentCity,
  tariffs: state.intercom.tariffs,
});

const mapDispatchToProps = dispatch => ({
  getIntercomTariffs: hostname => dispatch(getIntercomTariffs(hostname)),
});

export default connect(mapStateToProps, mapDispatchToProps)(IntercomTariffPage);
